import React from 'react'
import { Theme, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'

import FirstPageRounded from '@mui/icons-material/FirstPageRounded'
import LastPageRounded from '@mui/icons-material/LastPageRounded'
import NavigateBeforeRounded from '@mui/icons-material/NavigateBeforeRounded'
import NavigateNextRounded from '@mui/icons-material/NavigateNextRounded'

type IProps = {
    totalItems: number
    itemsPerPage: number
    page: number
    setPage: React.Dispatch<React.SetStateAction<number>>
}

const useStyles = makeStyles((theme: Theme) => ({
  pagination: {
    margin: '0',
    display: 'flex',
    padding: 0,
    flexWrap: 'wrap',
    listStyle: 'none',
    alignItems: 'center',
  },
  pageLink: {
    margin: '0 1px',
  },
  disabled: {
    opacity: 0.38,
    pointerEvents: 'none',
    cursor: 'default',
  },
}))

export default function Pagination (props: IProps) {
  const { totalItems, itemsPerPage, page, setPage } = props
  const totalPages = Math.ceil(totalItems / itemsPerPage)

  const classes = useStyles()
  const { t } = useTranslation()

  const onFirstPage = (): void => {
    setPage(1)
  }

  const onLastPage = (): void => {
    setPage(totalPages)
  }

  const onNextPage = (): void => {
    setPage(page + 1)
  }

  const onPreviousPage = (): void => {
    setPage(page - 1)
  }

  const getItemsCounter = () => {
    let fromTo = ''
    if (page === 1) {
      fromTo = `${page}-${itemsPerPage}`
    } else if (page > 1 && page !== totalPages) {
      fromTo = `${((itemsPerPage * page) - itemsPerPage) + 1}-${itemsPerPage * page}`
    } else {
      fromTo = `${(itemsPerPage * page) - (itemsPerPage - 1)}-${totalItems}`
    }
    return `${fromTo} ${t('coreDashboard:of')} ${totalItems}`
  }

  return (
    <>
      {totalItems > itemsPerPage && (
        <nav style={{ marginTop: '8px' }}>
          <ul className={classes.pagination}>
            <li style={{ marginRight: '12px' }}>
              {getItemsCounter()}
            </li>
            <li>
              <IconButton
                className={`${classes.pageLink} ${page === 1 && classes.disabled}`}
                color='primary'
                component='div'
                onClick={() => onFirstPage()}
                size='large'
              >
                <FirstPageRounded />
              </IconButton>
            </li>
            <li>
              <IconButton
                className={`${classes.pageLink} ${page === 1 && classes.disabled}`}
                color='primary'
                component='div'
                onClick={() => onPreviousPage()}
                size='large'
              >
                <NavigateBeforeRounded />
              </IconButton>
            </li>
            <li>
              <IconButton
                className={`${classes.pageLink} ${page === totalPages && classes.disabled}`}
                color='primary'
                component='div'
                onClick={() => onNextPage()}
                size='large'
              >
                <NavigateNextRounded />
              </IconButton>
            </li>
            <li>
              <IconButton
                className={`${classes.pageLink} ${page === totalPages && classes.disabled}`}
                color='primary'
                component='div'
                onClick={() => onLastPage()}
                size='large'
              >
                <LastPageRounded />
              </IconButton>
            </li>
          </ul>
        </nav>
      )}
    </>
  )
}
